<template>
  <!-- TODO: get it back after removing the Backbone user bar -->
  <!--div class="le bubble-component-container user-bar-wrapper dark"-->
  <div class="persona-switcher-wrapper">
    <div class="app-header">

      <div ref="indicator" :style="indicatorPos" class="selected-indicator">
        <div class="selected-indicator-top">
        </div>
        <div class="selected-indicator-middle">
        </div>
        <div class="selected-indicator-bottom">
        </div>
      </div>
      <div class="personaSwitcher">
        <div v-for="(item, index) in switcherItems"
             :key="item.type"
             v-bind:href="`#${item.switcherRoute}`"
             :class="[item.className, {'router-link-active active': subIsActive(item)}]"
             :title="!item.notification.showTooltipOnNotification && item.tooltip"
             :tooltip-text="!item.notification.showTooltipOnNotification && item.tooltip"
             tooltip-position="right"
             tooltip-align="middle"
        >
          <div class="switcher-item"
               :title="item.notification.showTooltipOnNotification && item.tooltip"
               tooltip-position="right">
            <div class="icon-wrapper"
                 @keydown.enter.space="onSwitchItem(item, $event, index)"
                 @click="onSwitchItem(item, $event, index)"
                 role="button"
                 tabindex="0"
                 :aria-label="item.tooltip"
                 :aria-pressed="!!subIsActive(item)">
              <span v-if="item.iconClassName !== ''" class="icon"></span>
              <span v-if="item.fontIconName !== ''" :class="item.fontIconName" class="fontIcon"></span>
            </div>
          </div>
          <div class="notification" :class="item.notification.class">
            <div :key="item.notification.tooltip"
                 :title="item.notification.showTooltipOnNotification && item.notification.tooltip"
                 tooltip-position="right">{{ item.notification.count || "&nbsp;&nbsp;" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide-left">
      <keep-alive>
        <component v-if="isVueApp" :is="selectedApp"></component>
      </keep-alive>
    </transition>
  </div>
  <!--/div-->
</template>

<script>
let LocaleResolver = require('../../../assets/js/i18n/localeResolver.js');
import Vuex from 'vuex';
import navigator from 'routers/navigator';
import LEConfig from 'assets/config/le-env-conf';
import registerModule from 'src/modules/registerModule';
import * as Settings from 'assets/data/codeTables/settings.json';
import {
  environmentActionTypes,
  environmentGetterTypes,
  environmentStateKeys,
  gChannel,
  sessionActionTypes,
  sessionKeys,
  storeModuleTypes,
  sessionManager, ACClient, Logger,
} from 'vue-infra';
import ApiResources from "../../../assets/data/apiResources.json";
const logger = Logger.getLogger('LiveEngage:PersonaSwitcher');

const getters = Vuex.mapGetters(storeModuleTypes.ENVIRONMENT, {
  routes: environmentGetterTypes.ROUTES,
  regions: environmentGetterTypes.REGIONS,
  validApps: environmentGetterTypes.VALID_APPS,
  personaNotification: environmentGetterTypes.PERSONA_NOTIFICATION,
  currentPersona: environmentStateKeys.CURRENT_PERSONA,
});
const actions = Vuex.mapActions(storeModuleTypes.ENVIRONMENT, {
  setValue: sessionActionTypes.SET_VALUE,
  personaNotificationUpdate: environmentActionTypes.PERSONA_NOTIFICATION_UPDATE,
});
const lastRoutes = {};

export default {
  name: 'persona-switcher',

  created() {
    this.prevPath = this.$route.path;
    // don't move this to module scope, to ensure internal/external modules had been resolved
    this.internalModuleNames = registerModule.resolveInternalModules().map(module => module.moduleName);
    const url = ApiResources.AccountConfig.SiteSettings.url;
    const siteSettingsUrl = window.LE.urlResolver.getUrl(url);
    this.baseSiteSettings = new ACClient({
      allowedMethods: ['get', 'post'],
      config: {
        baseURL: siteSettingsUrl,
        params: {
          context_type: Settings.CONTEXT_TYPE.ACCOUNT,
          context_cascading: true,
          v: ApiResources.AccountConfig.SiteSettings.version
        },
      },
    })
  },

  async mounted() {
    gChannel.register('personaSwitcher', 'switch', options => this.switchItem(options));
    const isFirstTimeSiteSetting = await this.baseSiteSettings.get(Settings.SETTING_ID.FIRST_TIME_MC);
    if (isFirstTimeSiteSetting && isFirstTimeSiteSetting.data && isFirstTimeSiteSetting.data.propertyValue) {
      this.isFirstTime = (isFirstTimeSiteSetting.data.propertyValue.value === "true");
    }
  },

  data() {
    return {
      selectedItemPos: 0,
      isVueApp: false,
      baseSiteSettings: null,
      isFirstTime: false,
    };
  },

  methods: {
    subIsActive(item) {
      // explicitly test for index 1 (after the first '/'), to avoid partial matching in deep routes
      if (this.$route.path.indexOf(item.baseSwitcherRoute) === 1) {
        this.selectedItemPos = this.findItemInedexBy('baseSwitcherRoute', item.baseSwitcherRoute);
        return true;
      }
      return this.checkIfVisualModule(item);
    },

    checkIfVisualModule(item) {
      const appId = this.$route.path.split('/').filter(Boolean)[0];
      const visualModule = this.switcherItems.find((e) => {
        return e.baseSwitcherRoute === appId;
      });
      if (!visualModule && this.prevPath && this.prevPath === item.switcherRoute) {
        this.selectedItemPos = this.findItemInedexBy('relatedModuleName', item.relatedModuleName);
        return true
      }
      return false;
    },

    sortByFieldValue(fieldName, entry1, entry2) {
      return entry1[fieldName] - entry2[fieldName];
    },

    onSwitchItem(item, e, index) {
      e.preventDefault();
      this.switchItem({item});
    },

    async switchItem({item, switchedPersona, backBrowser = true}) {
      if (switchedPersona) {
        item = this.findItemBy('type', switchedPersona);
      }

      if (item.switcherRoute === "/mc") {
        try {
          await this.baseSiteSettings.patch(undefined, [{
            id: Settings.SETTING_ID.FIRST_TIME_MC,
            type: 2,
            propertyValue: {value: false},
          }], {
            revision: -1,
          });
        } catch (e) {
          logger.error(`Can not update site setting ${Settings.SETTING_ID.FIRST_TIME_MC} ,${e}`);
          this.isFirstTime = true;
        } finally {
          this.isFirstTime = false;
          item.notification.class = '';
        }
      }

      this.selectedItemPos = this.findItemInedexBy('relatedModuleName', item.relatedModuleName);
      // store last route for this module
      if (this.$router.currentRoute && this.currentPersona && this.currentPersona.relatedModuleName) {
        const currentPath = this.$router.currentRoute.path;
        if (currentPath.indexOf(this.currentPersona.baseSwitcherRoute) === 1) {
          lastRoutes[this.currentPersona.relatedModuleName] = currentPath;
        }
      }
      this.setValue({attribute: environmentStateKeys.CURRENT_PERSONA, value: item});

      // restore last module route
      const nextRoute = lastRoutes[item.relatedModuleName] ? lastRoutes[item.relatedModuleName] : item.switcherRoute;
      if (backBrowser) {
        this.$router.push(nextRoute);
      } else {
        this.$router.replace(nextRoute);
      }
      this.prevPath = this.$route.path;
    },

    findItemBy(propKey, propVal) {
      return this.switcherItems.find(item => item[propKey] === propVal);
    },

    findItemInedexBy(propKey, propVal) {
      return this.switcherItems.findIndex(item => item[propKey] === propVal);
    },

    setValue: actions.setValue,
  },

  computed: {
    indicatorPos() {
      return {
        transform: `translateY(${(50 * this.selectedItemPos) - 29 || -29}px)`
      }
    },

    switcherItems() {
      const switcherItems = [];
      if (this.regions && this.routes.length > 0) {
        Object.keys(this.regions).forEach((moduleName) => {
          const region = this.regions[moduleName];
          let switcherRoute;
          // region.shouldLoadApp should be undefined (when legacy) || true (when new app)
          if (region.switcherControl &&
            this.validApps.indexOf(region.switcherRoute) > -1) {
            let title;
            let tooltip = '';

            if (region.config.switcher && region.config.switcher.titleTranslationKey) {
              // first check if the key exist in the application dictionary
              title = this.$t(`${region.config.routePrefix}:${region.config.switcher.titleTranslationKey}`);
              if (title === region.config.switcher.titleTranslationKey) {
                // first check if the key exist in the application dictionary
                title = this.$translator.translate(sessionKeys.PERSONA_TITLE[region.persona]);
              }
            } else {
              title = this.$translator.translate(sessionKeys.PERSONA_TITLE[region.persona]);
            }

            if (this.validApps.indexOf('aw') > -1 && this.$translator.hasTranslationKey(LocaleResolver.getDefaultLocale(), `${sessionKeys.PERSONA_TITLE[region.persona]}.withNewAgentWorkspace`)) {
              title = this.$translator.translate(`${sessionKeys.PERSONA_TITLE[region.persona]}.withNewAgentWorkspace`);
            }


            if (region.config.switcher && region.config.switcher.tooltipTranslationKey) {
              // first check if the key exist in the application dictionary
              tooltip = this.$t(`${region.config.routePrefix}:${region.config.switcher.tooltipTranslationKey}`);
              if (tooltip === region.config.switcher.tooltipTranslationKey) {
                // first check if the key exist in the application dictionary
                this.$translator.translate(sessionKeys.DEFAULT_PERSONA_TOOLTIP_MAP[region.persona]);
              }
            } else {
              tooltip = !sessionKeys.DEFAULT_PERSONA_TOOLTIP_MAP[region.persona] ? '' :
                this.$translator.translate(sessionKeys.DEFAULT_PERSONA_TOOLTIP_MAP[region.persona]);
            }
            if (title && tooltip) {
              tooltip = `${title}`;
            }

            const moduleDefaultRoute = navigator.getDefaultRoute(moduleName);
            if (moduleDefaultRoute) {
              switcherRoute = `/${region.switcherRoute}/${moduleDefaultRoute}`;
            } else {
              if (this.internalModuleNames.includes(moduleName)) {
                switcherRoute = LEConfig.defaultRoute;
              } else {
                switcherRoute = `/${region.switcherRoute}`;
              }
            }
            const persona = region.persona || sessionKeys.PERSONA.GUEST;
            const notification = (this.personaNotification || {})[persona] || {};
            const hasNotification = (!Number.isNaN(notification.count) && notification.count > 0);

            const item = {
              type: persona,
              className: region.switcherControl || '',
              fontIconName: region.fontIconName || '',
              iconClassName: region.switcherIconClassName || '',
              relatedModuleName: moduleName || '',
              baseSwitcherRoute: region.switcherRoute,
              switcherIndex: region.switcherIndex || '',
              switcherRoute,
              tooltip: tooltip,
              itemTitle: title,
              notification: {
                count: notification.count,
                tooltip: notification.tooltip || '',
                class: hasNotification ? 'notificationOn' : '',
                showTooltipOnNotification: notification.showTooltipOnNotification
              },
            };

            if (region.switcherRoute === "mc" && this.isFirstTime) {
              item.notification.class = 'notificationOn';
            }

            if (item.tooltip && item.notification.tooltip && hasNotification) {
              item.tooltip = `${item.tooltip} (${item.notification.tooltip})`;
            }

            if (!region.fontIconName && !region.switcherIconClassName) {
              item.className = 'switcher-item-module-placeholder';
              item.iconClassName = 'switcher-item-module-placeholder';
            }

            switcherItems.push(item);
            // set first persona selected.
            if (this.$route.path.indexOf(item.switcherRoute) === 0) {
              this.setValue({attribute: environmentStateKeys.CURRENT_PERSONA, value: item})
            }
            // }
          }
        }, this);

        switcherItems.sort(this.sortByFieldValue.bind(this, 'switcherIndex'));
      }

      return switcherItems;
    },

    validApps: getters.validApps,
    regions: getters.regions,
    routes: getters.routes,
    personaNotification: getters.personaNotification,
    currentPersona: getters.currentPersona,
  },
  watch: {
    '$route'(to, from) {
      this.prevPath = from.path;
      if (this.$route.meta && this.$route.meta.marrionetteModule) {
        this.selectedApp = `${this.$route.meta.marrionetteModule}ChildProxy`;
        this.isVueApp = true;
      } else {
        this.isVueApp = false;
      }
    }
  }
};

</script>

<style lang='scss'>
@import "../../../assets/scss/global";
@import "../../../assets/scss/mixins";

.persona-switcher-wrapper {
  font-weight: 100;
  /*height: inherit;*/
  position: relative;
  z-index: 20;

  .app-header {
    width: 100%;
    height: 100%;

    .selected-indicator {
      z-index: 10;
      position: absolute;
      top: 0px;
      left: 8px;
      width: 48px;
      height: 100px;
      @include themify {
        $selected-module-component: getAttr('nav-bar-selected-module-component', 'framework');
        @include lp-bg-image('assets/img/' + $selected-module-component);
      }
    }

    .personaSwitcher {
      > * {
        position: relative;
      }

      margin-top: 30px;
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 20;
      display: flex;
      flex-direction: column;
      align-items: center;

      > div {
        height: inherit;
        display: inline-block;


        .switcher-item {
          cursor: pointer;
          height: 50px;

          > span {
            display: inline-block;
            vertical-align: middle;
            text-align: center;
          }

          .icon {
            display: inline-block;
            width: 23px;
            height: 23px;
            color: #cac7c7;
          }
        }


        .notification {
          float: left;
          display: none;
          margin: 5px 10px 0 0;
          @include themify {
            background-color: getColor('nav-bar-notification-bg', 'framework');
            color: getColor('nav-bar-notification-text', 'framework');
            text-shadow: -1px -1px 0 getColor('nav-bar-notification-text-border', 'framework'),
            1px -1px 0 getColor('nav-bar-notification-text-border', 'framework'),
            -1px 1px 0 getColor('nav-bar-notification-text-border', 'framework'),
            1px 1px 0 getColor('nav-bar-notification-text-border', 'framework'),
            1px 1px 5px getColor('nav-bar-notification-text-border', 'framework');
          }

          > div {
            display: inline-block;
            padding: 2px 5px 2px 5px;
            font-size: 11px;
            font-weight: bold;
            @include themify {
              background-color: getColor('nav-bar-notification-bg', 'framework');
              color: getColor('nav-bar-notification-text', 'framework');
              border-width: 1px;
              border-style: solid;
              border-color: getColor('nav-bar-notification-border', 'framework');
              text-shadow: -1px -1px 0 getColor('nav-bar-notification-text-border', 'framework'),
              1px -1px 0 getColor('nav-bar-notification-text-border', 'framework'),
              -1px 1px 0 getColor('nav-bar-notification-text-border', 'framework'),
              1px 1px 0 getColor('nav-bar-notification-text-border', 'framework'),
              1px 1px 5px getColor('nav-bar-notification-text-border', 'framework');
            }
            @include border-radius(8px);
            position: absolute;
          }

          &.notificationOn {
            display: inline-block;
            position: absolute;
            top: -13px;
            left: 19px;
          }
        }

        .icon-wrapper {
          transition: all 0.2s ease-out 0s;
          @include themify {
            background-color: getColor('transparent', 'framework');
          }
          border-radius: 50%;
          height: 32px;
          width: 32px;
          display: flex;
          align-items: center;
          justify-content: center;

          .fontIcon {
            @include themify {
              color: getColor('navigation-bar-icon-color', 'framework');
            }
            font-size: 22px;
            margin-left: 1px;
          }
        }

        &.router-link-active {
          .switcher-item {
            cursor: default;
          }

          .icon-wrapper {
            transition: all 0.2s ease-out 0s;
            @include themify {
              background-color: getColor('nav-bar-selected-icon-bg', 'framework');
            }
            border-radius: 50%;
            height: 32px;
            width: 32px;
            display: flex;
            align-items: center;
            justify-content: center;

            .fontIcon {
              @include themify {
                color: getColor('navigation-bar-icon-color-active', 'framework');
              }
              font-size: 22px;
            }

            &:focus,
            &:active {
              @include themify('light', 'show-a11y-focus-outline') {
                box-shadow: inset 0 0 0 2px getColor('b-primary-button-background-color', 'framework') !important
              }
            }
          }

          .notification {
            > div {
              font-size: 11px;
              font-weight: bold;
              @include themify {
                background-color: getColor('nav-bar-notification-bg', 'framework');
                color: getColor('nav-bar-notification-text', 'framework');
                text-shadow: -1px -1px 0 getColor('nav-bar-notification-text-border', 'framework'),
                1px -1px 0 getColor('nav-bar-notification-text-border', 'framework'),
                -1px 1px 0 getColor('nav-bar-notification-text-border', 'framework'),
                1px 1px 0 getColor('nav-bar-notification-text-border', 'framework'),
                1px 1px 5px getColor('nav-bar-notification-text-border', 'framework');
              }
              background-color: white;
            }
          }
        }
      }
    }
  }
}

@include registerSwitcherImage('item-module-placeholder', 'item-module-placeholder', 'itme-module-placeholder-selected', 'framework', './../../../assets/img/');
</style>



